module.exports = __webpack_public_path__ + "img/logo-new.59a73b97.8a7f1070.png";